import { render, staticRenderFns } from "./notification-elem-list.vue?vue&type=template&id=107b4c76&scoped=true"
import script from "./notification-elem-list.vue?vue&type=script&lang=js"
export * from "./notification-elem-list.vue?vue&type=script&lang=js"
import style0 from "./notification-elem-list.vue?vue&type=style&index=0&id=107b4c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107b4c76",
  null
  
)

export default component.exports